export enum DeviceType {
  ANDROID = 'ANDROID',
  IOS = 'IOS',
  PC = 'PC',
}
